import { ProtoReturnValue } from 'src/app/@core/types';

export function isEmptyObject(obj: { [key: string]: ProtoReturnValue }): boolean {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}
